var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative","width":"100%","height":"100%"}},[_c('div',{ref:"chartTide",style:({ width: _vm.width, height: _vm.height })})])}
var staticRenderFns = []

export { render, staticRenderFns }